import EmitterSubscription from './subscriptions/emitterSubscription';
import SubscriberRegistry from './suscriberRegistry';
/**
 * @class Emitter
 * Emitter allows to create/fire events and their respective handling.
 */
var Emitter = /** @class */ (function () {
    function Emitter() {
        this._subscriber = new SubscriberRegistry();
        this._currentSubscription = null;
    }
    Emitter.prototype.addListener = function (eventType, listener, context) {
        return this._subscriber.addSubscription(eventType, new EmitterSubscription(this._subscriber, listener, context));
    };
    /**
     * TODO: Add one time listener
     */
    // once(eventType: string, listener: Function, context?: Object): Subscription {
    //   const emitter = this;
    //   return this.addListener(eventType, function() {
    //     listener.apply(this, context);
    //     emitter.removeCurrentListener();
    //   });
    // }
    Emitter.prototype.removeCurrentListener = function () {
        if (this._currentSubscription)
            this._subscriber.removeSubscription(this._currentSubscription);
    };
    Emitter.prototype.removeAllListeners = function (eventType) {
        this._subscriber.removeAllSubscriptions(eventType);
    };
    Emitter.prototype.fire = function (eventType, args) {
        var _this = this;
        var subscriptions = this._subscriber.getSubscriptionsOfType(eventType);
        if (subscriptions) {
            subscriptions.forEach(function (subscription) {
                if (subscription) {
                    subscription.listener.apply(_this, args);
                    _this._currentSubscription = subscription;
                }
            });
        }
    };
    return Emitter;
}());
export default Emitter;
//# sourceMappingURL=emitter.js.map